import $ from 'jquery';

export function updateLinkState (container, url) {
  // Add current and child-current classes to links with the container,
  // depending on the current url
  // clear all
  const els = (container || $('body')).find('a[href]');
  url = url || (window.location.pathname + window.location.search);

  els.removeClass('current, child-current');
  els.each(function () {
    var href = ($(this).attr('href') || '').split('#')[0];
    $(this)[href === url ? 'addClass' : 'removeClass']('current');
    var childCurrent = url.indexOf(href) === 0 && href !== '/';
    $(this)[childCurrent ? 'addClass' : 'removeClass']('child-current');
  });
}



// WEBPACK FOOTER //
// ./assets/j/src/utilities.js